import { HiOutlineXMark } from 'react-icons/hi2'
import { Link } from 'react-router-dom'
import Logo from './Logo'

interface FullScreenLayoutProps {
  children: any
  title: string | JSX.Element
  subtitle?: string | JSX.Element
  className?: string
}

export default function FullScreenLayout({
  title,
  subtitle,
  children,
  className,
}: FullScreenLayoutProps) {
  return (
    <div>
      <div
        style={{
          height: '80px',
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 15,
          backgroundColor: '#2E2F3C',
        }}
      >
        <div
          className={`h-full flex flex-col-reverse items-start transition-all duration-500 md:flex-row md:justify-between md:items-center `}
          style={{marginTop:"1px"}}
        >
          <Link to="/">
            <div className="w-[150px]">
              <Logo className="ml-6" />
            </div>
          </Link>
          <div className="absolute right-4 top-8 text-white">
              <Link to="/"><HiOutlineXMark size={20} /></Link>
          </div>
        </div>
      </div>
      <div className={`w-full h-screen p-8 ${className ?? ''}`}>
        <div style={{height: '80px'}}>
        </div>
        <div className="text-center text-4xl font-semibold">{title}</div>
        {subtitle && (
          <div className="text-center mt-4 mb-8">
            <div className="text-xl my-4">{subtitle}</div>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  )
}
